import { PubFinEventId, PubFinEventDurationId } from '@/constants/pub_event';

let adv_data = {};

try {
    if (window.adv && window.adv.getMediaData) {
        adv_data = {
            ...adv_data,
            ...window.adv.getMediaData()
        };
    }
} catch (e) {
    console.log(e);
}

/**
 * 上报统计事件
 * @param  eventId 上报的事件名，唯一标志
 * @param attrs 类型必须为object 业务中需要上报的数据，可放在该key-value内
 * @returns 上报成功后回调
 */
export const trackEvent = (
    eventId: string,
    attrs?: { [key: string]: string | boolean | number | object | [] | undefined }
) => {
    return new Promise<void>((resolve, reject) => {
        if (window.Omega) {
            window.Omega.trackEvent(eventId, '', {
                ...adv_data,
                ...attrs,
            },
            () => {
                resolve();
            });
        } else {
            reject();
            throw new Error('omega is not init');
        }
    });
};

/**
 * 手动上报异常统计数据
 * @param name 异常统计的名称
 * @param code 异常的编码error code
 * @param label 异常的label
 * @param attrs 型必须为object 业务异常中需要上报的数据，可放在该key-value内
 */
export const trackError = (
    name: string,
    code: number,
    label: string,
    attrs?: { [key: string]: unknown }
) => {
    if (window.Omega) {
        window.Omega.trackError(name, code, label, attrs);
    } else {
        throw new Error('omega is not init');
    }
};

/**
 * 手动上报fmp，避免重复上报
 * @param params 上报参数
 */

let firstReportFmp = true;

export const trackFmp = (pageId: string, params: Record<string, string | object>) => {
    if (!firstReportFmp) return;
    trackEvent(
        PubFinEventId.pub_fintech_fe_duration_bt,
        {
            ...params,
            fe_page_id: pageId,
            fe_duration_id: PubFinEventDurationId.fmp,
            fe_duration_value: window.performance.now()
        }
    );
    performance.mark('fmp');
    firstReportFmp = false;
};
